import { useQuery } from '@tanstack/react-query';
import { withMedicalDisplayNames, type CartillaPlan } from '@/lib/planFilters';

export function usePlanes() {
  return useQuery({
    queryKey: ['planes'],
    queryFn: async () => {
      const res = await fetch('/api/planes');
      if (!res.ok) throw new Error('Error al obtener los planes');
      const data = await res.json();

      const allPlanes: CartillaPlan[] = Array.isArray(data.CARTILLA)
        ? data.CARTILLA
        : [data.CARTILLA];

      return withMedicalDisplayNames(allPlanes);
    },
    staleTime: 1000 * 60 * 60, // 1 hora
  });
}
